import { pathConfig } from '../config';
export const paths = {
    generalData: pathConfig.api + 'general/data',
    requestSave: pathConfig.api + 'request/save',
    requestLaborSave: pathConfig.api + 'request/labor/save',
    requestDomiciledSave: pathConfig.api + 'request/domicile/save',
    savePersonalInfoApi: pathConfig.api_nest + 'api/solicitud/personal-info/save',

    path: pathConfig.app
}